/**
 * @name RowsPerPage
 * @description Control de registros por página del datagrid
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

// Material-UI
import MuiTablePagination from '@material-ui/core/TablePagination';
import { withStyles } from '@material-ui/core/styles';

import { Icons, Theme, Typography } from '@styles';

const RowsPerPage = (props) => {
  const {
    rowsLength,
    pageSize,
    currentPage,
    onChangePageSize,
  } = props;

  return (
    <Styled.FlexTablePagination>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={rowsLength}
        rowsPerPage={pageSize}
        page={currentPage}
        onChangePage={(e, page) => null}
        onChangeRowsPerPage={onChangePageSize}
        labelRowsPerPage={i18n.t('GenericMessages.show')}
        labelDisplayedRows={({ count }) => {
          const items = count > 1
            ? i18n.t('GenericMessages.items').toLowerCase()
            : i18n.t('GenericMessages.item').toLowerCase();
          const label =
            <span>
              {i18n.t('GenericMessages.of')}
              <Typography.Medium>{` ${count} `}</Typography.Medium>
              {items}
            </span>;
          return label;
        }}
        SelectProps={{
          // eslint-disable-next-line react/display-name
          IconComponent: () => <Icons.ArrowDown />
        }}
      />
    </Styled.FlexTablePagination>
  );
};

RowsPerPage.propTypes = {
  // Longitud de registros.
  rowsLength: PropTypes.number,
  // Número de registro por página. 
  pageSize: PropTypes.number,
  // Número de página actual.
  currentPage: PropTypes.number,
  // Función a ejecutar cuando se cambie el número de registros por página.
  onChangePageSize: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexTablePagination = styled.div`
  display: flex;
  flex-basis: 200px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
`;

// Table Pagination
Styled.TablePagination = styled(MuiTablePagination)`
  .MuiTablePagination-toolbar{
    padding: 8px 0px;
  }

  .MuiTablePagination-select {
    padding-left: 0px;
  }

  .MuiInputBase-root {
    margin: 0 8px 0 8px;
    font-family: 'Bryant Pro Regular';
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
  }

  .MuiTypography-root {
    font-family: 'Bryant Pro Regular';
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
  }

  /* Hide Previous/Next Buttons */
  .MuiTablePagination-actions {
    display: none;
  }

  /* Select Icon */
  .MuiSvgIcon-root {
    right: 0;
    position: absolute;
    pointer-events: none;
    font-size: 20px;
  }
`;

// Table Pagination w/Styles
const TablePagination = withStyles(() => ({
  menuItem: {
    padding: '0px 16px',
    minHeight: '40px',
    fontFamily: 'Bryant Pro Regular',
    fontSize: Theme.typography.bodyText,
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    whiteSpace: 'normal',
    color: Theme.colors.greyDark
  }
}))(Styled.TablePagination);

export default RowsPerPage;